// extracted by mini-css-extract-plugin
export default {"userTagWrapper":"index_userTagWrapper__pWZ-S","iconContainer":"index_iconContainer__7BhCP","nameContainer":"index_nameContainer__2blW6"};